import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {WhiteListsState} from './types';
import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';

export const state: WhiteListsState = {
    whiteLists: []
};


export const whiteLists: Module<WhiteListsState, RootState> = {
    state,
    getters,
    actions,
    mutations
};
